export const generateProformaInvoiceTemplate = (dataInvoice) => {
  // Currency conversion constants and function
  const {
    invoiceDate = dataInvoice.InvoiceDate,
    invoiceNo = dataInvoice.InvoiceNo,
    placeOfSupply = dataInvoice.PlaceOfSupply,
    po = dataInvoice.PO,
    dispatchFrom = dataInvoice.DispatchFrom,
    shipTo = dataInvoice.ShipTo,
    eInvoiceAckNo = dataInvoice.EInvoiceAckNo,
    eInvoiceDate = dataInvoice.EInvoiceDate,
    packagingNote = dataInvoice.PackagingNote,
    unit = dataInvoice.Unit,
    pricePerUnit = dataInvoice.PricePerUnit,
    quantity = dataInvoice.Quantity,
    subTotal = dataInvoice.SubTotal,
    igstPercent = dataInvoice.IgstPercent,
    cgstPercent = dataInvoice.CgstPercent,
    sgstPercent = dataInvoice.SgstPercent,
    igstAmount = dataInvoice.IgstAmount,
    cgstAmount = dataInvoice.CgstAmount,
    sgstAmount = dataInvoice.SgstAmount,
    totalAmount = dataInvoice.TotalAmount,
    ewayBillNo = dataInvoice.EwayBillNo,
    vehicleNo = dataInvoice.VehicleNo,
    eInvoiceIRN = dataInvoice.EInvoiceIRN,
    productName = dataInvoice.ProductName,
    grade = dataInvoice.Grade,
    HSCode = dataInvoice.HSCode,
    companyName= dataInvoice.CompanyName || "",
    companyAddress= dataInvoice.CompanyAddress || "",
    companyCity= dataInvoice.CompanyCity || "",
    companyState= dataInvoice.CompanyState || "",
    companyZipCode= dataInvoice.CompanyZipCode || "",
    companyGSTIN= dataInvoice.CompanyGSTIN || "",
  } = dataInvoice;

  // Function to convert number to words (Indian numbering system)
  const numberToWords = (num) => {
    if (num === 0) return 'Zero';

    const ones = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 
                  'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const thousands = ['Thousand', 'Lakh', 'Crore'];

    const belowHundred = (n) => {
      if (n < 20) return ones[n];
      if (n < 100) {
        const ten = Math.floor(n / 10);
        const unit = n % 10;
        return unit === 0 ? tens[ten - 2] : `${tens[ten - 2]} ${ones[unit]}`;
      }
      return '';
    };

    const convert = (num) => {
      if (num === 0) return '';
      if (num < 100) return belowHundred(num);

      let result = '';
      let unitIndex = 0;
      while (num > 0) {
        if (unitIndex === 0) {
          // Handle hundreds
          const hundreds = Math.floor(num % 1000);
          if (hundreds > 0) {
            const hundredText = hundreds < 100 ? belowHundred(hundreds) : `${ones[Math.floor(hundreds / 100)]} Hundred${hundreds % 100 > 0 ? ' ' + belowHundred(hundreds % 100) : ''}`;
            result = hundredText + (result ? ' ' + result : '');
          }
          num = Math.floor(num / 1000);
          unitIndex++;
        } else if (unitIndex === 1) {
          // Handle thousands
          const thousandsNum = Math.floor(num % 100);
          if (thousandsNum > 0) {
            result = belowHundred(thousandsNum) + ' ' + thousands[0] + (result ? ' ' + result : '');
          }
          num = Math.floor(num / 100);
          unitIndex++;
        } else if (unitIndex === 2) {
          // Handle lakhs
          const lakhs = Math.floor(num % 100);
          if (lakhs > 0) {
            result = belowHundred(lakhs) + ' ' + thousands[1] + (result ? ' ' + result : '');
          }
          num = Math.floor(num / 100);
          unitIndex++;
        } else if (unitIndex === 3) {
          // Handle crores
          const crores = Math.floor(num % 100);
          if (crores > 0) {
            result = belowHundred(crores) + ' ' + thousands[2] + (result ? ' ' + result : '');
          }
          num = Math.floor(num / 100);
          unitIndex++;
        }
      }
      return result.trim();
    };

    const wholePart = Math.floor(num);
    let words = convert(wholePart);
    return `Rupees ${words} Only`;
  };

  // Convert totalAmount to words
  const totalAmountInWords = numberToWords(totalAmount);

  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Proforma Invoice</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      font-size: 0.875rem; /* 14px base */
      background: #f5e6dc;
      margin: 0;
      padding: 2%;
    }
    .invoice-box {
      background: #fff;
      padding: 2%;
      border: 2px solid #000;
      max-width: 1100px;
      width: 96%;
      margin: auto;
      box-sizing: border-box;
    }
    .header {
      text-align: center;
      font-size: 1.25rem; /* 20px */
      font-weight: bold;
      text-transform: uppercase;
      border-bottom: 2px solid #000;
      padding-bottom: 0.625rem; /* 10px */
      margin-bottom: 0.625rem;
    }
    .row {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .col {
      width: 48%;
      font-size: 0.8125rem; /* 13px */
      line-height: 1.5;
    }
    .col1 {
      width: 38%;
      font-size: 0.8125rem;
      line-height: 1.5;
    }
    .col2 {
      width: 29%;
      font-size: 0.8125rem;
      line-height: 1.5;
    }
    .col3 {
      width: 29%;
      font-size: 0.8125rem;
      line-height: 1.5;
    }
    table {
      width: 100%;
      border-collapse: collapse;
    }
    table, th, td {
      border: 1px solid #000;
    }
    th, td {
      padding: 0.25rem; /* 4px */
      text-align: left;
    }
    .no-border {
      border: none !important;
    }
    .note {
      font-size: 0.75rem; /* 12px */
      margin-top: 0.625rem;
      width: 50%;
      line-height: 1.8;
    }
    .footer {
      text-align: right;
      margin-top: 1.875rem; /* 30px */
      font-weight: bold;
      width: 50%;
    }
    .title-cell {
      font-weight: bold;
      font-style: italic;
    }
    .bank-table td:first-child {
      font-weight: bold;
      width: 30%;
    }
    .bank-table td:last-child {
      font-style: italic;
      font-weight: bold;
    }
    .triple-table {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 0.9375rem; /* 15px */
    }
    .triple-table table {
      width: 32%;
      min-width: 200px;
    }
    .triple-table th {
      background: #fff;
      font-weight: bold;
      text-align: center;
    }
    .bill-content {
      text-align: left;
      font-style: italic;
      font-weight: bold;
      padding: 0.3125rem; /* 5px */
    }
    .border-1 {
      border: 1px solid;
      padding: 0.1875rem; /* 3px */
    }
    .invoice-data td {
      padding: 0.5rem 0.3125rem; /* 8px 5px */
    }
    .display-flex {
      display: flex;
    }
    .logo-img {
      max-width: 100%;
      height: auto;
      display: block;
    }
    .margin-top-10 {
      margin-top: 10px
    }
    /* Media Queries for Responsiveness */
    @media screen and (max-width: 768px) {
      .col, .col1, .col2, .col3 {
        width: 100%;
        margin-bottom: 1rem;
      }
      .triple-table table {
        width: 100%;
        margin-bottom: 1rem;
      }
      .note, .footer {
        width: 100%;
        text-align: left;
      }
      .invoice-box {
        padding: 3%;
      }
      .header {
        font-size: 1rem;
      }
      table {
        font-size: 0.75rem;
      }
    }
    @media screen and (max-width: 480px) {
      body {
        padding: 1%;
      }
      .invoice-box {
        width: 98%;
      }
      th, td {
        padding: 0.2rem;
      }
      .header {
        font-size: 0.875rem;
      }
      table {
        font-size: 0.7rem;
      }
      .bill-content {
        font-size: 0.7rem;
      }
    }
  </style>
</head>
<body>
  <div class="invoice-box">
    <div class="header">PROFORMA INVOICE</div>
    <div class="row">
      <div class="col1 border-1">
        <strong>Agropreneurs Market Technologies Pvt. Ltd.</strong><br>
        Gujarat Technological University, Store(R&B),<br>
        Sub Division, Block-3, LD Engineering College,<br>
        Compound Navrangpura, Ahmedabad-380015<br>
        GSTIN - 24AACZ1441M1ZB<br>
        PAN - AACZ1441M<br>
        Mob - 9830172791<br>
        Email - prasun.dey@agropreneurs.in
      </div>
      <div class="col2">
        <img src="https://internal.grainsglobaldev.com/images/logo.png" alt="Logo" class="logo-img">
      </div>
      <div class="col3">
        <table>
          <tr><td>Date</td><td>${invoiceDate}</td></tr>
          <tr><td>Invoice No.</td><td>${invoiceNo}</td></tr>
          <tr><td>Place of Supply</td><td>${placeOfSupply}</td></tr>
          <tr><td>PO</td><td>${po}</td></tr>
          <tr><td>E-Invoice Ack No</td><td>${eInvoiceAckNo}</td></tr>
          <tr><td>E-Invoice Date</td><td>${eInvoiceDate}</td></tr>
        </table>
      </div>
    </div>
    <div class="triple-table margin-top-10">
      <table>
        <tr><th>Bill To1</th></tr>
        <tr>
          <td class="bill-content">
            ${companyName}<br>
            ${companyAddress}<br>
            ${companyCity}-${companyZipCode}<br>
            ${companyState}<br><br>
            GSTIN - ${companyGSTIN}
          </td>
        </tr>
      </table>
      <table>
        <tr><th>Dispatch From</th></tr>
        <tr>
          <td class="bill-content">
            ${dispatchFrom}
          </td>
        </tr>
      </table>
      <table>
        <tr><th>Ship To</th></tr>
        <tr>
          <td class="bill-content">
            ${shipTo}
          </td>
        </tr>
      </table>
    </div>
    <table class="margin-top-10">
      <tr>
        <th>Description of Goods</th>
        <th>HSN Code</th>
        <th>QTY</th>
        <th>Unit</th>
        <th>Price per unit</th>
        <th>Subtotal (in INR)</th>
      </tr>
      <tr>
        <td style="text-align:left;">
          ${productName} - ${grade}<br>
          <small>(${packagingNote})</small>
        </td>
        <td>${HSCode}</td>
        <td>${quantity}</td>
        <td>${unit}</td>
        <td>${pricePerUnit}</td>
        <td>${subTotal}</td>
      </tr>
    </table>
    <div class="row margin-top-10">
      <div class="col">
        <table>
          <tr>
            <td class="title-cell">Amount in words</td>
          </tr>
          <tr>
            <td>${totalAmountInWords}</td>
          </tr>
        </table>
        <table class="bank-table">
          <tr>
            <td>E Way Bill No.</td>
            <td>${ewayBillNo}</td>
          </tr>
          <tr>
            <td>Vehicle No.</td>
            <td>${vehicleNo}</td>
          </tr>
          <tr>
            <td>E-Invoice IRN</td>
            <td>${eInvoiceIRN}</td>
          </tr>
        </table>
        <table class="bank-table">
          <tr>
            <td>Bank Name</td>
            <td>HDFC BANK LIMITED</td>
          </tr>
          <tr>
            <td>Branch Name</td>
            <td>Ahmedabad</td>
          </tr>
          <tr>
            <td>Account Number</td>
            <td>50200087730152</td>
          </tr>
          <tr>
            <td>IFSC Code</td>
            <td>HDFC0009659</td>
          </tr>
        </table>
      </div>
      <div class="col">
        <table class="invoice-data">
          <tr><td class="no-border">Subtotal</td><td>${subTotal}</td></tr>
          <tr><td class="no-border">IGST @ ${igstPercent}%</td><td>${igstAmount}</td></tr>
          <tr><td class="no-border">CGST @ ${cgstPercent}%</td><td>${cgstAmount}</td></tr>
          <tr><td class="no-border">SGST @ ${sgstPercent}%</td><td>${sgstAmount}</td></tr>
          <tr><td class="no-border">Round Off</td><td>0.00</td></tr>
          <tr><th>Total (in INR)</th><th>${totalAmount}</th></tr>
        </table>
      </div>
    </div>
    <div class="display-flex">
      <div class="note">
        <strong>Note:</strong><br>
        1. All disputes are settled in Ahmedabad Jurisdiction only.<br>
        2. Payment Terms - 100% advance<br>
        3. Late payment will attract an interest charge of 18% per month, calculated on the outstanding amount.
      </div>
      <div class="footer border-1">
        for Agropreneurs Market Technologies Pvt. Ltd.<br><br>
        <i>(Authorised Signatory)</i>
      </div>
    </div>
  </div>
</body>
</html>
  `;
};

// Function to open Proforma Invoice popup with print functionality
export const openProformaInvoicePopup = (dataInvoice) => {
  const invoiceHTML = generateProformaInvoiceTemplate(dataInvoice);

  // Create a new window for the invoice
  const printWindow = window.open(
    "",
    "_blank",
    "width=1024,height=600,scrollbars=yes,resizable=yes"
  );

  if (printWindow) {
    printWindow.document.write(invoiceHTML);
    printWindow.document.close();

    // Add print button functionality
    printWindow.onload = function () {
      // Add print button to the document
      const printButton = printWindow.document.createElement("button");
      printButton.innerHTML = "🖨️ Print Proforma Invoice";
      printButton.className = "print-button";

      printButton.onclick = function () {
        printWindow.print();
      };

      printWindow.document.body.appendChild(printButton);

      // Focus the window
      printWindow.focus();
    };
  } else {
    alert("Please allow popups to view the invoice");
  }
};